import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'end',
    justifyContent: 'space-between',
  },
  addFilterButton: {
    margin: theme.spacing(1),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'auto',
  },
  filterOptionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  firstRowFormControl: {
    width: theme.spacing(20),
    height: theme.spacing(6),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  formControl: {
    width: theme.spacing(20),
    height: theme.spacing(6),
    marginRight: theme.spacing(1),
  },
  formField: {
    color: '#1C2541',
  },
  removeFilterButton: {
    marginTop: theme.spacing(1.5),
    marginRight: theme.spacing(1),
  },
  logicOperatorFormControl: {
    width: theme.spacing(12.5),
    height: theme.spacing(6),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(-1),
  },
  submitButton: {
    margin: theme.spacing(1),
  },
}));
